import { render, staticRenderFns } from "./commune-search.vue?vue&type=template&id=0d2f5f3e&"
import script from "./commune-search.vue?vue&type=script&lang=js&"
export * from "./commune-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports